import React from 'react';

/**
 * APEX Design System — Card
 *
 * Container standard pour grouper du contenu.
 * Border zinc-800 + fond zinc-950 + padding cohérent.
 *
 * Variants:
 *   - default : carte standard
 *   - elevated: avec léger glow cyan (pour mettre en avant)
 *   - danger  : border rose pour zones critiques
 *   - subtle  : sans bordure, juste fond
 *
 * Padding:
 *   - none : pas de padding (gérer en interne)
 *   - sm   : p-3 (densité dashboard)
 *   - md   : p-4 (défaut)
 *   - lg   : p-6 (aéré)
 */

const VARIANTS = {
  default: 'border border-zinc-800 bg-zinc-950',
  elevated: 'border border-cyan-400/30 bg-zinc-950 shadow-[0_0_24px_-12px_rgba(34,211,238,0.4)]',
  danger: 'border border-rose-400/30 bg-rose-400/5',
  subtle: 'bg-zinc-900'
};

const PADDINGS = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6'
};

export default function Card({
  children,
  variant = 'default',
  padding = 'md',
  className = '',
  onClick,
  ...rest
}) {
  const isClickable = !!onClick;
  return (
    <div
      onClick={onClick}
      className={`
        ${VARIANTS[variant]}
        ${PADDINGS[padding]}
        ${isClickable ? 'cursor-pointer hover:border-zinc-700 transition' : ''}
        ${className}
      `}
      {...rest}
    >
      {children}
    </div>
  );
}
